<template>
  <div>
    <CustomDialogWrapper dialogType="showBindPhone" dialogHeight="280px" @closeDialog="closeDialog">
      <template #title>
        <p :class="$style.title">手机验证</p>
      </template>
      <template #main-content>
        <van-form validate-first>
          <div :class="`${$style['form-item']}`">
            <span :class="active == 1 && $style.active">手机号</span>
            <van-field
              v-model="phoneNumber"
              :class="`${$style.value} ${active == 1 && $style.active}`"
              type="tel"
              clearable
              error-message-align="right"
              :rules="[
                {
                  required: true,
                  message: '手机号码不能为空',
                  trigger: 'onBlur',
                },
                {
                  pattern: /^1[0-9]{10}$/,
                  message: '请输入正确的手机号码',
                  trigger: 'onBlur',
                },
              ]"
              @focus="handleBlur(1)"
            />
          </div>
          <div :class="`${$style['form-item']}`">
            <span :class="active == 2 && $style.active">验证码</span>
            <van-field
              v-model="verifyCode"
              :class="`${$style.value} ${active == 2 && $style.active}`"
              type="number"
              clearable
              error-message-align="right"
              @focus="handleBlur(2)"
            >
              <template #button>
                <van-button
                  v-show="!hasVerifyCode"
                  :class="$style['get-code-btn']"
                  size="mini"
                  type="info"
                  plain
                  round
                  @click.native="getVerifyCode"
                >
                  获取
                </van-button>
                <van-count-down
                  v-show="hasVerifyCode"
                  ref="countDown"
                  seconds
                  :time="60000"
                  format="ss 秒后重发"
                  :auto-start="false"
                  :style="{ color: '#ccc', fontSize: '12px' }"
                  @finish="timeFinished"
                >
                </van-count-down>
              </template>
            </van-field>
          </div>
        </van-form>
      </template>
      <template #footer>
        <van-button :class="$style.submit" type="info" @click="submit">立即验证</van-button>
      </template>
    </CustomDialogWrapper>
  </div>
</template>
<script>
import CustomDialogWrapper from './CustomDialogWrapper';
import { Form, Field, Button, Dialog, Toast, CountDown } from 'vant';
import { getVerifyCode, bindUserPhone } from '@/api/app';
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  components: {
    CustomDialogWrapper,
    VanForm: Form,
    VanField: Field,
    VanButton: Button,
    VanCountDown: CountDown
  },
  data() {
    return {
      showBindPhone: false,
      phoneNumber: '', // 手机号码
      verifyCode: '', // 验证码
      active: undefined,
      hasVerifyCode: false, // 是否获取了验证码
      brushFlag: false, // 防止重复提交
    };
  },
  computed: {
  },
  methods: {
    ...mapMutations('app', {
      CHANGE_BIND_PHONE: 'CHANGE_BIND_PHONE'
    }),
    ...mapActions('account', {
      getUserInfo: 'getUserInfo'
    }),
    // 获取验证码
    async getVerifyCode() {
      if (!this.phoneNumber) {
        Dialog.confirm({
          title: '温馨提示',
          message: '请先输入手机号码',
        }).then(() => {
        }).catch(() => {
        });
        return
      }
      try {
        const r = await getVerifyCode({
          phone: this.phoneNumber
        });
        Toast('验证码已发送！')
      } catch (error) {
        Toast(error.message)
      }
      this.hasVerifyCode = true
      this.$refs.countDown && this.$refs.countDown.start();
    },
    // 立即验证
    async submit() {
      if (!this.phoneNumber) {
        Dialog.alert({
          title: '温馨提示',
          message: '手机号码不能为空',
        }).then(() => {
        });
        return
      }
      if (!this.verifyCode) {
        Dialog.alert({
          title: '温馨提示',
          message: '验证码不能为空',
        }).then(() => {
        });
        return
      }
      if (this.brushFlag) return;
      this.brushFlag = true;
      try {
        const r = await bindUserPhone({
          phone: this.phoneNumber,
          code: this.verifyCode
        });
        Toast.success("绑定成功");
        this.CHANGE_BIND_PHONE(false);
        this.getUserInfo()
      } catch (error) {
        Toast.fail(error.message);
      } finally {
        this.brushFlag = false
      }
    },
    handleBlur(type) {
      this.active = type
    },
    closeDialog() {
      this.CHANGE_BIND_PHONE(false)
    },
    timeFinished() {
      this.hasVerifyCode = false
    }
  },
}
</script>

<style lang='scss' module>
@import '~@/styles/mixins.scss';
.title {
  margin-bottom: 30px;
  font-size: 15px;
  line-height: 18px;
  color: #9d9d9d;
}
.form-item {
  display: flex;
  margin: auto;
  align-items: center;
  width: 90%;
  > span {
    margin-right: 20px;
    flex: none;
    color: #9d9d9d;
    display: inline-block;
    &.active {
      color: #33bdfe;
    }
  }
  .value {
    @include border-bottom-1px;
    padding: 5px 10px;
    &.active {
      &::before {
        border-color: #33bdfe;
      }
    }
  }
  .get-code-btn {
    padding: 0 10px;
    height: 20px;
    border-radius: 20px;
    color: #33bdfe;
    border-color: #33bdfe;
    font-size: 12px;
  }
}
.submit {
  width: 247px;
  border-radius: 22px;
  background: linear-gradient(-90deg, rgba(36, 180, 254, 1), rgba(82, 208, 255, 1));
  border: none;
}
</style>
